<template>
  <span class="profile-avatar">

    <el-dropdown
        v-if="currentProfile"
        class="profile-drop"
        @command="handleCommand"
    >
      <span class="el-dropdown-link">
        <el-avatar class="no-focus profile-avatar__image" :style="{ background: avatarColor(currentProfile.id) }">{{
            avatarChar(currentProfile.name)
          }}</el-avatar>
      </span>
      <el-dropdown-menu size="medium" slot="dropdown" trigger="hover">
        <div class="profile-card">
          <div class="profile-card__name">{{ currentProfile.name }}</div>
          <div class="profile-card__email">{{ currentProfile.email }}</div>
        </div>
        <el-dropdown-item command="profile">Мой профиль</el-dropdown-item>
        <el-dropdown-item command="logout" divided>Выйти</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

     <span class="profile-avatar__medical medical" v-if="currentProfile">
      <div class="medical__name" v-if="currentProfile">{{ currentProfile.email }}</div>
      <div class="medical__email" v-if="currentProfile">{{ currentProfile.email }}</div>
    </span>
  </span>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "ProfileAvatarButton",
  methods: {
    ...mapActions({
      showProfile: "dialogs/profile/show",
    }),
    ...mapActions({
      close: 'dialogs/profile/clear',
    }),
    handleCommand(command) {
      if (command === "logout")
        this.$store
            .dispatch("auth/LOGOUT")
            .then(() => {
              this.$notify.success({
                title: "Удачно...",
                message: "До свидания!",
              });
            })
            .catch(() => {
              this.$notify.error({
                title: "Упс...",
                message: "Ошибка всязи 😕",
              });
            })
            .finally(() => {
              this.$router.push({name: "auth.signin"});
            });
      if (command === "fake") this.fake();

      if (command === "profile") this.showProfile()

      if (command === "clear_cache")
        this.$api.system.clearCache().then(() => {
          this.$message({
            message: "cacheSuccess",
            type: "success",
          })
        })
    },
    avatarColor(id) {
      let colors = [
        "linear-gradient(234deg, rgba(34,193,195,1) 30%, rgba(253,187,45,1) 100%)",
        "linear-gradient(234deg, rgba(63,94,251,1) 30%, rgba(252,70,107,1) 100%)",
        "linear-gradient(234deg, rgba(131,58,180,1) 30%, rgba(253,29,29,1) 50%, rgba(252,176,69,1) 100%)",
        "linear-gradient(234deg, rgba(234,150,46,1) 30%, rgba(246,2,105,1) 100%)",
        "linear-gradient(234deg, #FFC839 30%, #32E6BE 100%)",
        "linear-gradient(234deg, #9774ec 30%, #4bafec 100%)",
        "linear-gradient(234deg, #4bafec 30%, #9774ec 100%)",
      ];
      let color = id % colors.length;
      return colors[color];
    },
    avatarChar(name) {
      return name.charAt(0).toUpperCase();
    }
  },
  computed: {
    ...mapState("auth", {
      currentProfile: (state) => state.profile,
    }),
    ...mapState("session", {
      session: (state) => state.session,
    }),
    ...mapState('dialogs/profile', {
      form: state => state,
    }),
    visible: {
      get() {
        return this.status === "visible";
      },
      set() {
        this.status = "hidden";
      },
    },
  },
};
</script>

<style scoped lang="scss">


.profile-avatar {
  display: flex;
  align-items: center;
  justify-content: space-between;

  //@media screen and (max-width: 500px) {
  //  display: none;
  //}

  .medical {


    &__name {
      font-size: 12px;
      line-height: 13px;
      text-align: right;

      color: #111111;
    }
    &__email {
      font-size: 11px;
      line-height: 13px;

      color: #8E8E93;
      margin-top: 4px;
    }


    @media screen and (max-width: 600px) {
      display: none;
    }
  }

  &__image {
    transition: box-shadow 300ms ease-out;

    &:hover {
      box-shadow: 0 0 0 3px #ffffff38;
    }
  }
}

.profile-card {
  padding: 10px 20px;

  &__name {
    font-weight: 500;
    font-size: 15px;
  }

  &__email {
    margin-top: 10px;
    font-size: 12px;
  }
}

.profile-drop {
  color: #fff;
  cursor: pointer;
  margin-right: 10px;

  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
